import { render, staticRenderFns } from "./TransferConversationModal.vue?vue&type=template&id=ee2e2dd0&scoped=true&"
import script from "./transfer-conversation-modal.ts?vue&type=script&lang=ts&"
export * from "./transfer-conversation-modal.ts?vue&type=script&lang=ts&"
import style0 from "./TransferConversationModal.vue?vue&type=style&index=0&id=ee2e2dd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2e2dd0",
  null
  
)

export default component.exports